/*jshint esversion: 6 */

import React from 'react';

class CaQuizFeedback extends React.Component {

    render(){
        const {title, cta ,onClick ,noBackground} = this.props;
        let { bodyContent} = this.props;

        if ( !!bodyContent && bodyContent.toLowerCase().indexOf("<p>") == -1 ) bodyContent = "<p>"+bodyContent+"</p>";

        return(
            <div className={"QuizComponentView QuizComponentView--alignMiddle QuizFeedback"+(noBackground?" QuizFeedback--nobg":'')} >
                <div className={"QuizComponentView__content QuizComponentView__content--alignMiddle"}>
                    <h1 className={"QuizFeedback__title"} >{title}</h1>
                    <div className={"QuizFeedback__content"}  dangerouslySetInnerHTML={{__html: bodyContent}} />
                    {
                        !!cta && !!onClick && (
                            <div className={"QuizFeedback__buttonWrapper"}>
                                <button className={"QuizFeedback__submitButton"} onClick={() => onClick()}>{cta}</button>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}
export default CaQuizFeedback;